import script from "./SubtaskProgressBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./SubtaskProgressBadge.vue?vue&type=script&setup=true&lang=js"

import "./SubtaskProgressBadge.vue?vue&type=style&index=0&id=7efce1f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7efce1f8"]])

export default __exports__